import type { ReactNode } from 'react';
import React, { useState } from 'react';
import { useStyletron } from 'baseui';
import type { StyleObject } from 'styletron-react';
type PropT = {
  isOpen: boolean;
  styles?: StyleObject;
  enterStyle: StyleObject;
  exitStyle: StyleObject;
  duration: number;
  onExitAnimationEnd?: () => void;
  children: ReactNode;
  id?: string;
};
const AnimationContainer = ({
  styles,
  duration,
  isOpen,
  children,
  enterStyle,
  exitStyle,
  onExitAnimationEnd,
  id
}: PropT) => {
  const [css] = useStyletron();
  const [isInDom, setIsInDom] = useState(isOpen);
  if (isInDom === false && isOpen) {
    setIsInDom(true);
  }
  function handleOnAnimationEnd() {
    if (isInDom === true && !isOpen) {
      setIsInDom(false);
      onExitAnimationEnd?.();
    }
  }
  if (!isInDom) {
    return null;
  }
  const styleToAppend = isOpen ? exitStyle : enterStyle;
  return <div data-testid="animationDiv" id={id} onAnimationEnd={handleOnAnimationEnd} className={css({
    ...styles,
    // Appending the final state to the base style as animation style is removed once the animation ends.
    ...styleToAppend,
    animationName: {
      to: !isOpen ? enterStyle : exitStyle,
      from: !isOpen ? exitStyle : enterStyle
    },
    animationDuration: `${duration.toString()}ms`
  })}>
      {children}
    </div>;
};
export default React.memo<PropT>(AnimationContainer);